var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchCurrentUser } from "../../api/userService";
import { fetchAgencyPublisherBySourceId } from "../../api/publisherService";
import { firstOnix } from "../../utils/selectMappers";
import { normalizeMunicipality } from "../../utils/normalizeMunicipality";
export var useOwnerPublisherPrefill = function (_a) {
    var enabled = _a.enabled, publisherRoleTable = _a.publisherRoleTable, setValue = _a.setValue, setOwnerOptions = _a.setOwnerOptions, setPublisherOptions = _a.setPublisherOptions, municipality = _a.municipality;
    var ky = useOkapiKy();
    var prefillDoneRef = useRef(false);
    useEffect(function () {
        if (!enabled)
            return;
        if (!publisherRoleTable)
            return;
        if (prefillDoneRef.current)
            return;
        prefillDoneRef.current = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var currentUser, _a, activeOrg, activeOrganizationSourceId, agencyPublisher, ownerForForm, ownerOption_1, primaryPublisherRole, publicationPlace, e_1;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        currentUser = null;
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchCurrentUser(ky)];
                    case 2:
                        currentUser = _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _g.sent();
                        currentUser = null;
                        return [3 /*break*/, 4];
                    case 4:
                        activeOrg = (_b = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) !== null && _b !== void 0 ? _b : (_c = currentUser === null || currentUser === void 0 ? void 0 : currentUser.userOrganizations) === null || _c === void 0 ? void 0 : _c[0];
                        activeOrganizationSourceId = activeOrg === null || activeOrg === void 0 ? void 0 : activeOrg.sourceId;
                        if (!activeOrganizationSourceId)
                            return [2 /*return*/];
                        return [4 /*yield*/, fetchAgencyPublisherBySourceId(ky, activeOrganizationSourceId)];
                    case 5:
                        agencyPublisher = _g.sent();
                        if (!agencyPublisher)
                            return [2 /*return*/];
                        ownerForForm = {
                            id: agencyPublisher.id,
                            sourceId: agencyPublisher.sourceId,
                            name: (_d = agencyPublisher.name) !== null && _d !== void 0 ? _d : "",
                            qualifier: agencyPublisher.qualifier || undefined,
                            status: agencyPublisher.status,
                            registrations: agencyPublisher.registrations || undefined,
                            dataConfirmationTime: agencyPublisher.dataConfirmationTime || "",
                        };
                        ownerOption_1 = {
                            value: String(agencyPublisher.id),
                            label: (_e = agencyPublisher.name) !== null && _e !== void 0 ? _e : "",
                        };
                        setOwnerOptions([ownerOption_1]);
                        setPublisherOptions(function (prev) {
                            var map = new Map(prev.map(function (o) { return [o.value, o]; }));
                            map.set(ownerOption_1.value, ownerOption_1);
                            return Array.from(map.values());
                        });
                        setValue("owner", ownerForForm, {
                            shouldDirty: false,
                            shouldTouch: false,
                            shouldValidate: false,
                        });
                        primaryPublisherRole = ((_f = publisherRoleTable === null || publisherRoleTable === void 0 ? void 0 : publisherRoleTable.onixCodetableItems) === null || _f === void 0 ? void 0 : _f.find(function (i) { return i.value === "01"; })) || firstOnix(publisherRoleTable);
                        setValue("titlePublishers", [{ publisher: ownerForForm, role: primaryPublisherRole }], { shouldDirty: false, shouldTouch: false, shouldValidate: false });
                        publicationPlace = normalizeMunicipality(municipality);
                        if (publicationPlace) {
                            setValue("publicationPlaces", [{ city: publicationPlace }], {
                                shouldDirty: false,
                                shouldTouch: false,
                                shouldValidate: false,
                            });
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _g.sent();
                        // eslint-disable-next-line no-console
                        console.error("Prefill owner/publisher failed", e_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); })();
    }, [
        enabled,
        publisherRoleTable,
        ky,
        setValue,
        setOwnerOptions,
        setPublisherOptions,
        municipality,
    ]);
};
